import * as React from "react";
import DemoButtons from "./Utiilities/DemoButtons";
import ImageSction1 from "../Assests/Images/Ed365/ImageSection1.png";
import Plans from "./Utiilities/Plans";
import Accordion from "./Utiilities/AccordionItem";
import SpecailButtons from "./Utiilities/SpecialButtons";
import Header from "./Header and Footer/Header";
import Footer from "./Header and Footer/Footer";
import ScrollToTop from "./Utiilities/ScrolltoTop";
import G2Badge from "./Utiilities/G2Badge";
import TabsWithImage from "./Utiilities/TabsWithImage";
import Availability from "./Utiilities/Availability";
import OurClients from "./Utiilities/OurClients";
import Integration from "./Utiilities/Integration";
import { MyContext } from "../App";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import GetOfferPage from "./Utiilities/GetOfferPage";
import CustomPlans from "./Utiilities/CustomPlans";
import Azuer from "./Utiilities/Azuer";
import OverviewCommon from "./GlobalMultiple/OverviewCommon";
import CyberSecurity from "./Utiilities/CyberSecurity";
import OverviewCommonET from "./GlobalMultiple/OverviewCommonET";
import LogoSlider from "./Utiilities/Slider";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import OverviewCommonLMS365 from "./GlobalMultiple/OverviewCommonLMS365";
import { Dropdown, PrimaryButton, TextField } from "@fluentui/react";
import OverviewCommonAsset365 from "./GlobalMultiple/OverviewCommonAsset365";
import Trustedbylogo from "./GlobalMultiple/Trustedbylogo";
// import { mouseflow} from "react-mouseflow";
const logos = [
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/soc_142hvt-qc.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/compliants_tM_PrC8N0Z.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/iso_D4yJ25IRn.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/microsoft_vdp9CYFMBj.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20ROI%201_96Mf_DosK.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/medal%20(2)_JiluXJRGNl.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20support%201_IGpX8xxqe3.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/great-place_C3JVU5GXk.png",
];
function RM365() {

    //GTM
    const script = document.createElement("script");
    script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'functionality_storage': 'denied',
          'security_storage': 'granted',
          'wait_for_update': 500
        });
      `;
    document.head.appendChild(script);

    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    const [ham, setHam] = React.useState(false);
    const AppName = React.useContext(MyContext);
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState("");
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const openLightbox = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const getEmbedUrl = (url) => {
        if (url.includes("youtube.com/watch?v=")) {
            return url.replace("watch?v=", "embed/");
        } else if (url.includes("youtu.be/")) {
            const videoId = url.split("youtu.be/")[1];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes("vimeo.com/")) {
            const videoId = url.split("vimeo.com/")[1];
            return `https://player.vimeo.com/video/${videoId}`;
        } else {
            return url; // fallback for direct video links
        }
    };
    const handlePlayClick = () => {
        setIsVideoPlaying(true); // When play icon is clicked, play the video
    };
    const handleCloseVideo = () => {
        setIsVideoPlaying(false); // Close the video
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // React.useEffect(() => {
    //   document.title = "new title"
    // }, []);
    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    React.useEffect(() => {
        document.title = "Smarter Way to Manage Assets – Powered by Asset 365";
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly."
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.content = "Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.";
            document.head.appendChild(newMeta);
        }
    }, []);
    // const AppName = React.useContext(MyContext);

    // const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    // const [selectedImageUrl, setSelectedImageUrl] = React.useState("");

    // const openLightbox = (imageUrl) => {
    //   setSelectedImageUrl(imageUrl);
    //   setLightboxOpen(true);
    // };

    // const closeLightbox = () => {
    //   setLightboxOpen(false);
    // };

    const accordionItems = [
        {
            title: "What is LMS 365, and how does it work?",
            content: `LMS 365 is a cloud-based SharePoint Learning Management System that integrates seamlessly with Microsoft 365. It enables organizations to deliver, track, and manage employee training within familiar apps like Teams, SharePoint, and Outlook, making learning accessible and efficient.`,
        },
        {
            title: `What makes LMS 365 different from other LMS platforms?`,
            content: `LMS 365 integrates directly with Microsoft 365, offering a seamless
experience without leaving the familiar environment. It offers features such as automation of course enrollments, reminders, and completions, along with course authoring tools, mobile learning, compliance tracking, certification management, and a user-friendly learning portal—making it a truly comprehensive learning management solution
 `,
        },
        {
            title: `Why is integration with Microsoft 365 important when choosing the best learning management system?`,
            content: `Integration with Microsoft 365 boosts usability and adoption, as it places the learning environment directly into tools employees already use (e.g., Teams and Outlook). This unified setup, offered by LMS 365, improves engagement, simplifies administration, strengthens security via Azure AD integration, and streamlines training workflows—all essential qualities of the best learning management system`,
        },
        {
            title:
                "Can I create custom courses with Microsoft Learning Management System?",
            content: `Yes! Microsoft Learning Management System includes built-in course authoring tools that allow organizations to create, customize, and deliver engaging training programs. You can incorporate videos, quizzes, and interactive content to enhance the learning experience.`,
        },
        {
            title: "Does Microsoft LMS 365 offer mobile learning?",
            content: `Absolutely! Microsoft LMS 365 is mobile-friendly, allowing employees to access courses anytime, anywhere from their smartphones or tablets. This flexibility ensures that learning is convenient and accessible, even for remote or on-the-go employees.`,
        },
        {
            title: "Can an Enterprise Learning Management System be customized?",
            content: `Absolutely! Most Enterprise Learning Management Systems offer customization options, including branding with logos and colors, custom course creation with videos and quizzes, and role-based access for better management. Multi-language support and personalized learning paths help cater to diverse workforce needs. These features enhance engagement, improve training efficiency, and support organizational goals.`,
        },
        {
            title: "Can SharePoint Management System automate training processes?",
            content: `Yes, SharePoint Management System automates training processes such as course enrolments, reminders, and certification tracking using Power Automate. This reduces administrative workload, ensuring employees complete their training on time with minimal manual intervention`,
        },
        {
            title: "How does LMS 365 support compliance training?",
            content: `LMS 365 simplifies compliance training by automating course assignments, tracking completions, and sending reminders. Organizations can ensure employees complete mandatory training on time, reducing the risk of compliance violations and improving audit readiness.`,
        },
        {
            title: `Which currency are the prices listed in?`, content: (
                "All prices are listed in USD."

            )
        },
    ];
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Asset Software - Simplify Asset Tracking &
                        Lifecycle Management</title>
                    <meta
                        name="description"
                        content="Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly."
                    />
                </Helmet>
                <ScrollToTop />
                <div className={`HR_MainHeaderSection HR_panelHeader`} style={{ background: "#000" }}>
                    <div className="HR_FlexCenterSpcBetween ETHR_FlexCenterSpcBetween">
                        <div className="HR_LogoSection">
                            <img
                                src={
                                    AppName == "Apps365"
                                        ? "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Logos/apps365white_yKjtDjv_y.png"
                                        : "https://ik.imagekit.io/zn4au2jftpm5/hr365/LOGO/91d92cd8-0bec-4bcc-8a8a-b069094eb852_BmoafHbFDy.png"
                                }
                                alt="Apps 365"
                            />
                            {""}


                            <div className="DB_button">
                                <DemoButtons StickyButton={true} getStarted={true} openDialog={true} Dialogheading={"See how Recruitment Management 365 adds value to your organization's training needs before you make a decision"} DialogDescription={"Enter your details and our experts will get in touch with you soon."} />
                            </div>
                            <div>
                                <span className="MBHAMBURGER" onClick={() => setHam(!ham)}>
                                    <RxHamburgerMenu />
                                </span>
                                {/* <span className="MBHAMBURGER" onClick={() => setHam(!ham)}> ≡</span> */}
                            </div>
                        </div>

                        <div className="HR_FlexCenterSpcBetween">
                            <div
                                className="HR_navMenu ETHR_navMenu LMSNavmenu "
                                style={{ paddingLeft: "0" }}
                            >
                                <span>
                                    <ul>
                                        <li>
                                            <div className="AM-logoIcons LMSLogoIconsStyles">
                                                <img
                                                    alt="MainImage"
                                                    src="https://ik.imagekit.io/apps365/Apps365/Logos/Asset365.png"
                                                ></img>

                                            </div>
                                        </li>
                                        <li>
                                            <a href="#Features">Features</a>
                                        </li>

                                        <li>
                                            <a href="#ClientsSpeakTestimonial">Testimonial</a>
                                        </li>
                                        <li>
                                            <a href="#Integration-ET">Integration</a>
                                        </li>
                                        <li>
                                            <a href="#pricing">Pricing</a>
                                        </li>
                                    </ul>
                                </span>
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={false} getStarted={false} />
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={true} getStarted={false} />
                            </div>
                        </div>
                    </div>
                </div>

                {ham ? (
                    <div
                        className="MBHB"
                        style={{
                            position: "fixed",
                            zIndex: "9",
                            top: "0vw",
                            paddingTop: "0.4vw 3vw",
                            background: "var(--panelBgColor)",
                            height: "100vh",
                        }}
                    >
                        <div className="mbflex">
                            <div className="HR_LogoSection">
                                <img
                                    src={
                                        "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Logos/apps365white_yKjtDjv_y.png"
                                    }
                                    alt={AppName}
                                />
                                {/* <a href="https://www.apps365.com" target="_blank" rel="noreferrer">
                <img src={"https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"} alt="Apps365" />
                {""}
              </a> */}
                            </div>

                            {ham ? (
                                <div
                                    onClick={() => setHam(!ham)}
                                    style={{ margin: "12px 0px" }}
                                >
                                    <span className="cross">
                                        <RxCross1 />
                                    </span>
                                </div>
                            ) : (
                                <div onClick={() => setHam(!ham)}>
                                    <span className="cross">+</span>
                                </div>
                            )}
                        </div>
                        <div>
                            <span>
                                <ul className={`${ham ? "mbmenu" : ""}`}>
                                    <li>
                                        <div className="ET-logoIcons ET-logoIconsOnMobileView ">
                                            <img
                                                alt="MainImage"
                                                src="https://ik.imagekit.io/apps365/App-Logos/Coloured-Logos/LMS.webp"
                                            ></img>
                                            <h3 className="HR_primaryclr">Recruitment Management 365</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <a href="#Features" onClick={() => setHam(false)}>
                                            Features
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#ClientsSpeakTestimonial"
                                            onClick={() => setHam(false)}
                                        >
                                            Clients
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#Integration-ET" onClick={() => setHam(false)}>
                                            Integration
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#pricing" onClick={() => setHam(false)}>
                                            Pricing
                                        </a>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* <Header HR365header="ET365" /> */}

                <div
                    style={{
                        backgroundColor: "unset",
                        background:
                            "linear-gradient(110deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                    }}
                >
                    <div
                        className="HR_panel"
                        style={{
                            padding: "3vw 5vw 1vw 3vw",
                            background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                        }}
                    >
                        <div className="HR_FlexCenterSpcBetween HR_ParentSection1 ET365HomepageParentsection">
                            <div className="HR_Section1LeftSide LMS365-HR_Section1LeftSide">
                                <h1
                                    className="HR_primaryclr"
                                    style={{
                                        fontSize: "3vw !important",
                                        fontWeight: "800 !important",
                                        color: "#333 !important",
                                    }}
                                >
                                    Smarter Way to Manage Assets – Powered by Asset 365
                                </h1>
                                <span className="ET365-HerosectionSubheading"></span>
                                <p
                                    className="HR_textclr LMSHR_textclr" style={{ marginTop: "0.4vw" }}

                                >
                                    <span >
                                        {" "}
                                        Experience seamless asset tracking and management with Apps365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.
                                    </span>
                                </p>

                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="See RM 365 Live in Action"
                                />
                            </div>
                            <div className="HR_Section1RightSide" style={{ width: "60%" }}>
                                <img
                                    className="HeroSectionImageStyles"
                                    style={{ width: "100%" }}
                                    alt="LMS 365 -Microsoft 365 Integrated LMS for Employee Training"
                                    src="https://ik.imagekit.io/zn4au2jftpm5/LMS%20apps/LMS%20365%20learning%20management%20system_IZMjTH-hk.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <Trustedbylogo />
                        <div style={{ paddingTop: "1vw" }}></div>
                        <OverviewCommonAsset365
                            MainHeading="Simplified Enterprise Asset Management Software with AI Integration"
                            MainDescription="Track and manage your assets effortlessly with our AI-powered SharePoint Asset Management system. With automated workflows and intelligent solutions, asset management is streamlined, letting you focus on growing your business."
                            MainImageAlt="ET365"
                        />
                        <div style={{ background: "linear-gradient(200deg, rgb(199 231 255 / 59%), rgb(226 208 255 / 64%), rgb(229 221 252 / 75%), rgb(217 206 236 / 67%), rgb(196 218 235 / 60%))" }}>
                            <h2
                                style={{ margin: "0px", paddingTop: "1.5vw", color: "#333" }}
                                className="HR_heading  ETHR_heading LMS_FeatureHeading"
                            >
                                AI-Powered LMS 365 Features Built for Effective, Consistent Learning
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "2vw" }}>
                                Create engaging courses, monitor learning performance, manage certifications, and ensure compliance —all through one unified, Microsoft 365-native LMS 365 platform.
                            </p>
                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div className="gifVideoStyles">
                                    <h2>IT asset management software integrated with Azure</h2>
                                    <ul>
                                        <li className="AI-DescriptionStyles">Microsoft Asset Management App integrates seamlessly with Microsoft Intune for dynamic asset retrieval and effective management of software licenses, service agreements, and Office 365 subscriptions in SharePoint.</li>
                                        <li className="AI-DescriptionStyles">It supports flexible asset allocation across users, groups, and locations, optimizing resource use.</li>
                                        <li className="AI-DescriptionStyles">The robust workflow engine automates renewals, enhancing efficiency, while the Azure Asset Management App continuously updates the Azure asset inventory for improved management.</li>
                                    </ul>
                                </div>
                                <div style={{ width: "40%" }}>
                                    <img style={{ width: "100%" }} src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/azure_Faooyo8YDz.gif?updatedAt=1720174577090" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages">
                                <div>
                                    <h2>Barcode Scanning, Image Capture, and Document Management with SharePoint IT Asset Management solutions</h2>
                                    <ul>
                                        <li className="AI-DescriptionStyles">ITAM software generates barcodes and QR codes for easy tracking through the asset monitoring app.</li>
                                        <li className="AI-DescriptionStyles">Asset details can be verified with mobile devices or barcode scanners, improving efficiency.</li>
                                        <li className="AI-DescriptionStyles">The tool also links comprehensive documentation to each asset, including manuals, support contacts, and guidelines, ensuring easy access to relevant information.</li>
                                    </ul>
                                </div>
                                <div style={{ width: "65%" }}>
                                    <img src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div className="gifVideoStyles">
                                    <h2>Asset Management Application: In-Depth Reports </h2>
                                    <ul>
                                        <li className="AI-DescriptionStyles">Seamless data export to Excel for your convenience.li</li>
                                        <li className="AI-DescriptionStyles">Effortless customization of column order to match your preferences.</li>
                                        <li className="AI-DescriptionStyles">Comprehensive view of all assets across the organization.</li>
                                        <li className="AI-DescriptionStyles">Addition of custom columns to incorporate personalized insights.
                                        </li>
                                        <li className="AI-DescriptionStyles">Enhanced data exploration with advanced search capabilities and filters.
                                        </li>
                                        <li className="AI-DescriptionStyles">Automated report generation schedules for regular updates.
                                        </li>
                                        <li className="AI-DescriptionStyles">
                                            Integration with other software tools for comprehensive data analysis
                                        </li>
                                        <li className="AI-DescriptionStyles">Real-time data synchronization for up-to-date information.

                                        </li>
                                        <li className="AI-DescriptionStyles">Easy export and sharing options within Microsoft 365.
                                        </li>
                                    </ul>
                                </div>
                                <div style={{ width: "40%" }}>
                                    <img src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Skills Assessment & Recognition   </h2>
                                    <p className="AI-DescriptionStyles">Evaluate employee knowledge with built-in quizzes, tests, and assignments. Upon successful completion, award certifications and digital badges that provide verifiable proof of skill development—not just course attendance, but demonstrated expertise.
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Easy-to-Use%20and%20Accessible_eU5Atwaskr.png?updatedAt=1756382760407" alt="" />
                                </div>
                            </div>

                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Stop Managing Training Manually   </h2>
                                    <p className="AI-DescriptionStyles">LMS 365 automates course enrollments, sends reminders, and tracks completions from one centralized system—reducing administrative burden and accelerating training delivery across your entire organization.
                                    </p>
                                </div>
                                <div style={{ width: "47%" }}>
                                    <img src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/Stop-Feature-LMS365_MtgEzUSMpK.png" alt="" />
                                </div>
                            </div>
                            <div class="et-feature-container LMS365FeatureCards" style={{ paddingTop: "0" }}>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/hr365/Icons/Microsoft%20365_PcKxwxZ9Cy.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">
                                        Integration with Microsoft 365
                                    </h3>
                                    <p class="et-feature-desc">
                                        Seamlessly blend learning into daily workflows with Microsoft Teams, SharePoint, and Outlook integration.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/hr365/Icons/Learning%20Automation_pWIQy79cKG.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">AI-Powered LMS Portal</h3>
                                    <p class="et-feature-desc">
                                        Empower employees with a user-friendly portal to track their learning progress, access courses, and manage certifications.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/hr365/Icons/Course%20Authoring_hIYptDF02q.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Course Authoring</h3>
                                    <p class="et-feature-desc">
                                        Easily create customized courses with built-in authoring tools, enabling personalized and engaging learning experiences.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/hr365/Icons/Flexible%20&%20Mobile%20Learning_2H663fKsN.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Flexible & Self-Paced Learning</h3>
                                    <p class="et-feature-desc">
                                        Empower employees to learn anytime, anywhere with mobile-friendly and on-demand courses.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/Engagement%20Tracking_7mDGkK4Fef.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Engagement Tracking</h3>
                                    <p class="et-feature-desc">
                                        Monitor learner participation in surveys, quizzes, and discussion boards to trigger support if needed.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/Social%20Sharing_falMFRTXrI.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Social Sharing</h3>
                                    <p class="et-feature-desc">
                                        Enable employees to share certificates and badges on social media, encouraging recognition and enhancing the company's brand.
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div
                            style={{
                                padding: "3vw",
                                background: "none",
                                paddingBottom: "2vw",
                            }}
                            className="overviewsection ETOverViewSection"
                        >
                            <h2 className="HR_heading" style={{ marginBottom: "0.5vw", color: "#333", margin: "0", paddingTop: "1.5vw" }}>
                                Why choose Recruitment Management 365?
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0" }}>
                                Built for Microsoft 365, LMS 365 delivers a simple, consistent learning experience across your entire organization. Create tailored learning paths, support global teams with multilingual courses, and give employees the flexibility to train on any device. Enable faster learning, better performance, and a more capable workforce.

                                {" "}
                            </p>

                            <div
                                className="cybersection cybersectionET"
                                style={{ background: "none", paddingBottom: "1vw", paddingTop: "2vw" }}
                            >
                                <CyberSecurity PageName="ET365" />
                            </div>
                        </div>

                        <div></div>

                        <section className="sec">
                            <div>
                                <div
                                    className="easy"
                                    style={{ background: "none", padding: "0vw 5vw 3vw 5vw" }}
                                >
                                    <div className="Avilcard1 LMS_Avilcard1" >
                                        <div className="AvilcardStyle">
                                            <div className="stickerStyles">
                                                <div className="sticker">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/customer-support_wPk-OuZ23.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                            </div>
                                            <h3 className="custom" style={{ color: "#2323CE" }}>
                                                Customer Support
                                            </h3>
                                            <p className="easypera">
                                                Our support team merges technical prowess with sincere
                                                care, fostering trust through expertise and empathy.
                                                They build lasting relationships, transcending mere
                                                service to create meaningful connections.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="availcard2">
                                        <div className="cd1">
                                            <div
                                                className="c1"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon1">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/setting_z7IzKFspuo.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt1">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        {" "}
                                                        AI Enabled Apps
                                                    </h3>
                                                    <p className="easypera">
                                                        Our innovative apps are built with the options of
                                                        Azure AI, Copilot, and custom AI solutions.
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                className="c2"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon2">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/interface%20(1)_Bn8jFsKJE.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt2">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Modern UI/UX
                                                    </h3>
                                                    <p className="easypera">
                                                        Every app is crafted using the latest Fluent UI,
                                                        ensuring seamless functionality across all devices.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cd2">
                                            <div
                                                className="c3"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon3">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/cloud-storage_wjvbbJkVt.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt3">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Swift Deployment
                                                    </h3>
                                                    <p className="easypera">
                                                        Choose any deployment
                                                        method—Teams,
                                                        Outlook, or SharePoint—that suits your preferences.
                                                    </p>
                                                    <span id="ClientsSpeakTestimonial" />
                                                </div>
                                            </div>
                                            <div
                                                className="c4"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon4">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/refresh__OBoe0tcU.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt4">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Free Updates{" "}
                                                    </h3>
                                                    <p className="easypera">
                                                        Our valued subscribers enjoy unlimited support,
                                                        enhancements, features, and updates.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div id="client" className="IdChanges"></div>
                    <div
                        className="HR_whitesection"
                        style={{ background: "none", padding: "0vw 5vw 1vw 5vw" }}
                    >
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", margin: "0" }}>Customer Testimonials</h2>
                        <p class="et-integration-subtitle CustomerReviewStyles AI-DescriptionStyles">
                            SharePoint Learning Management System drives learning that makes a difference built for the people who use it, empowering growth every step of the way.
                        </p>
                        <div className="HR_MT">
                            <OurClients />
                        </div>
                    </div>
                    <div class="et-integration-section LMS_integration-section" >
                        <div style={{ width: "100%" }}>
                            <h2 class="et-integration-title lMS_integration-title" >
                                Powerful Integrations,<br /> Zero Platform Switching
                            </h2>
                            <p class="et-integration-subtitle lMS_integration-subtitle" >
                                Easily set up, customize, and manage your learning platform directly within Microsoft Teams, SharePoint, and Outlook. LMS 365 automates training workflows and delivers real-time insights without adding extra systems to manage—making training, tracking, and skill development simpler and more effective.
                            </p>
                            <span id="pricing" />
                        </div>
                        <div style={{ width: "61%", margin: "0", padding: "0vw", }}>
                            <img src="https://ik.imagekit.io/cubiclogics/giff%20file/AM/Asset-Management-withbg.gif" alt="" />
                            {/* <video
                                src="https://ik.imagekit.io/apps365/Apps365/LMS/LMS%20(1).mp4"
                                autoPlay
                                muted
                                loop
                                playsInline
                                style={{ width: "85%", borderRadius: "0.5vw" }}

                            /> */}

                        </div>

                        {/* <div class="LMS-integration-grid">
              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Automate%20(1)_eXEyQVXbrh.png?updatedAt=1735914125187"
                  />{" "}
                </div>
                <h3 class="et-card-title">Power Automate</h3>
                <p class="et-card-description">
                  Save time by automating ticket updates, notifications, and
                  approvals for smoother support management.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Bi%20(1)_Kds_Hz7QcQ.png?updatedAt=1735914124948"
                  />
                </div>
                
                <h3 class="et-card-title">Power BI</h3>
                <p class="et-card-description">
                  Generate clear and detailed reports to better analyse support
                  performance and make informed decisions.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/power%20apps%20(1)_fKJEyRsAdu.png?updatedAt=1735914124951"
                  />
                </div>
                <h3 class="et-card-title">Power Apps</h3>
                <p class="et-card-description">
                  Use AI chatbots to instantly answer common customer support
                  queries or provide ticket updates.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20virtual%20Agent%20(1)_F7DLaFcFoe.png?updatedAt=1735914125177"
                  />
                </div>
                <h3 class="et-card-title">Power Virtual Agent</h3>
                <p class="et-card-description">
                  Build custom apps to enhance ticketing workflows and integrate
                  seamlessly with LMS 365.
                </p>
              </div>
            </div> */}

                    </div>

                    <div id="integration" className="IdChangesIntegration"></div>

                    <div className="IdChanges"></div>
                    <div className="HR_whitesection" style={{ background: "none" }}>
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", marginBottom: "0vw" }}>
                            Recruitment Management 365 Pricing & Plans
                        </h2>
                        <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "1vw" }}>
                            Strengthen your organization with LMS 365—the future of learning management!

                        </p>
                        <div className="HR_MT">
                            <div>
                                <Plans appName={"Recruitment Management 365"} />
                            </div>
                        </div>
                    </div>
                    <div className="AzureBoxStyles_LMS">
                        <div className="AzureBoxStyles_LMS_1">
                            <img style={{ width: "66%" }} src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.41vw" }}>Live on Azure</h3>
                            <p className="AzureText" style={{ textAlign: "center" }}>Buy directly from Azure Marketplace or via your enterprise agreement.</p>
                            <a className="Hr_Link" href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1">  Get started on Azure</a>
                        </div>
                        <div className="AzureBoxStyles_LMS_2" >

                            <img style={{ width: "65%" }} src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Random-Images/Untitled%20design%20(21)_nD6tRPn1n9.png" alt="" />
                            <h3 className="Azureheading">Special Pricing for NPOs</h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideSpecialrequest="hideSpecialrequest" SpecailButtonsText="Non-profits and government-funded educational institutes can avail exclusive rates." />
                        </div>
                        <div className="AzureBoxStyles_LMS_3">

                            <img style={{ width: "40%" }} src="https://ik.imagekit.io/apps365/Apps365/HD/Untitled%20design%20(27).webp" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.3vw" }}>Enterprise Pricing for 50+ Users
                            </h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideNPOrequest="hideNPOrequest" SpecailButtonsTextUser="Organizations with more than 50 users can avail special pricing." />
                        </div>


                    </div>
                    {/* <div
            className="Azuersection"
            style={{
              background: "none",
              paddingBottom: "0vw",
              paddingTop: "0vw",
            }}
          >
            <div className="AzureLogoText">
              <a
                href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                target="_blank"
              >
                <img
                  className="AzureImage"
                  src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png"
                  alt="Azure"
                />
              </a>
              <p className="AzureText">
                Using Azure? now you can{" "}
                <a
                  href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                  target="_blank"
                >
                  buy
                </a>
                on Azure Marketplace or using your enterprise agreement
              </p>
            </div>
          </div> */}


                    <span className="privacytext"></span>
                    <div id="faq" className="IdChangesIntegration"></div>
                    <div class="et et-demo-section">
                        <h1 class="et et-demo-heading" style={{ margin: "0", padding: "0", color: "#333", paddingTop: "2vw" }}>
                            Empower Your Workforce to Learn and Grow with Asset 365
                        </h1>
                        <p class="et et-demo-subtext AI-DescriptionStyles" style={{ marginBottom: "0" }}>
                            Join leading organizations prioritizing a highly engaged, modern
                            workforce.
                        </p>
                        <p class="et et-demo-subtext AI-DescriptionStyles">
                            Discover the full potentialof  Recruitment Management 365 today!
                        </p>
                        {/* <div class="et et-button-group">
              <DemoButtons
                hideDemoBtn="fasle"
                trailbtnText="Start Your 14-Day Free Trial button"
              />
            </div> */}
                        <form
                            id="lpgetstartedform"
                            className="lpgetstartedformclass "
                            style={{ padding: "2vw", background: "#f9faffbb", borderRadius: "0.5vw", paddingBottom: "0vw" }}
                        >
                            <div className="FooterContainer">
                                <div className="BottomFormleftimg">
                                    <img className="BottomFormImage" src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/LMS365-bottom-form_V3Jq3dsZk.png" alt="" />
                                </div>
                                <div className="FieldsButtonStyles">
                                    <div className="FormFieldStyles">
                                        <h3>Book a Personalized Recruitment Management 365 Demo!</h3>
                                        <DemoButtons LMS365demoForm={true} />
                                    </div>
                                    {/* <div className="ButtonandPrivacyText">
                    <PrimaryButton
                      style={{ background: "var(--btn-bg-color)", border: "none", fontSize: "1.1vw" }}
                      id="lpgetstartedsubmitbutton"
                      className="subButton"
                    // onClick={() => submitRequest("getstarted")}
                    >
                      {"Select a Time Slot"}

                    </PrimaryButton>

                  </div> */}
                                </div>
                            </div>
                        </form>
                        <div>
                            <h3 className="HR_faq">Frequently Asked Questions</h3>
                            <Accordion items={accordionItems} />
                        </div>
                    </div>
                </div>
                <Footer ET365={"ET365"} />
            </HelmetProvider>
        </>
    );
}
export default RM365;
